import { captureException } from '@sentry/react';
import { ErrorBoundary } from 'errors';
import React, { ErrorInfo, useCallback } from 'react';

import { News } from './News';

const App = () => {
  const handleError = useCallback((error: Error, errorInfo: ErrorInfo) => {
    captureException(error, {
      extra: {
        ...errorInfo,
      },
    });
  }, []);

  return (
    <ErrorBoundary onError={handleError}>
      <News />
    </ErrorBoundary>
  );
};

export default App;
